// @ts-strict-ignore
import { SampleRequestListUrlSortField } from "../../urls";

// Type based on your GraphQL query
type SampleRequestListQuery = {
  sampleRequests: {
    edges: Array<{
      node: {
        id: string;
        createdAt: string;
      };
    }>;
  };
};

export function getSampleRequestRowsLength(
  sampleRequests?: any[],
  loading?: boolean,
) {
  if (loading) {
    return 1;
  }

  if (sampleRequests?.length) {
    return sampleRequests.length;
  }

  return 0;
}

export function getColumnNameAndId(column: string): {
  columnName: SampleRequestListUrlSortField;
  columnId?: string;
} {
  if (column.includes(":")) {
    const [columnName, columnId] = column.split(":");

    return {
      columnName: columnName as SampleRequestListUrlSortField,
      columnId,
    };
  }

  return {
    columnName: column as SampleRequestListUrlSortField,
  };
}

export function canBeSorted(sort: SampleRequestListUrlSortField) {
  switch (sort) {
    case SampleRequestListUrlSortField.date:
    case SampleRequestListUrlSortField.customer:
      return true;
    default:
      return false;
  }
}